import { createFileRoute } from '@tanstack/react-router';
import { requireTemplatesFeature } from '@/features/project-templates/guard';
import { TemplateList } from '@/features/project-templates/template-list';

/** PROJ-08: manage project templates; behind the feature flag `project_templates`. */
export const Route = createFileRoute('/_app/project-templates')({
  beforeLoad: ({ context }) => requireTemplatesFeature(context.queryClient),
  component: TemplateList,
});
